<div class="status {{ data[header.field] }}">
    {{ data[header.field] }}
</div>
